import "v-tooltip/dist/v-tooltip.css";
import {
  MethodsFastReport,
  MethodsStrGet,
  MethodsStrSingleGet,
  MethodsStrSabitGet,
  MethodsStrFilterGet,
  MethodsStrPost,
  MethodsStrPut,
  MethodsStrPutList,
  MethodsStrDelete,
  MethodsActionsLogin,
  MethodsSetLogin,
  GenericComputed,
  MethodsTokenZamaniHesaplama,
  MethodsDeletePut,
  MethodsActionsDeleteParametre,
} from "@/state/helpers";

import moment from "moment";
const Sabit = {
  data() {
    return {
      apilanguages: {},
    };
  },
  methods: {
    ...MethodsFastReport,
    ...MethodsStrGet,
    ...MethodsStrSingleGet,
    ...MethodsStrSabitGet,
    ...MethodsStrFilterGet,
    ...MethodsStrPost,
    ...MethodsStrPut,
    ...MethodsStrPutList,
    ...MethodsStrDelete,
    ...MethodsActionsLogin,
    ...MethodsSetLogin,
    ...GenericComputed,
    ...MethodsTokenZamaniHesaplama,
    ...MethodsDeletePut,
    ...MethodsActionsDeleteParametre,
    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },
  },
  computed: {
    ...GenericComputed,
  },
  created() {
    this.Get();
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
    formatDateYear(value) {
      if (value) {
        return moment(String(value)).format("YYYY");
      }
    },
    formatDateTime(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY HH:DD");
      }
    },
    formatLongDate(value) {
      if (value) {
        var tarih = new Date(value);

        var bolunecek = moment(String(value)).format("DD.MM.YYYY.HH:DD");

        var tarihParcala = bolunecek.split(".");
        var gun = tarihParcala[0];
        var ay = tarihParcala[1] - 1; //ay verisi 0-11 arasında oldugu için bir eksiği alınır.
        var yil = tarihParcala[2];
        var saat = tarihParcala[3];

        var gunler = [
          "Pazar",
          "Pazartesi",
          "Salı",
          "Çarşamba",
          "Perşembe",
          "Cuma",
          "Cumartesi",
        ];
        var aylar = [
          "Ocak",
          "Şubat",
          "Mart",
          "Nisan",
          "Mayıs",
          "Haziran",
          "Temmuz",
          "Ağustos",
          "Eylül",
          "Ekim",
          "Kasım",
          "Aralık",
        ];
        var hangiGundeyiz = tarih.getDay();

        return (
          gun +
          " " +
          aylar[ay] +
          " " +
          yil +
          " " +
          gunler[hangiGundeyiz] +
          " günü, Saat :" +
          saat
        );
      }
    },
    formatNoktaToVirgul(value) {
      if (value) {
        return value.split(".").join(",");
      } else {
        return "";
      }
    },

    BindeAyiraci(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    TrParaFormat(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};

export default Sabit;
